<div class="content">
  <div
    class="title"
    i18n="@@Applications">
    Applications
  </div>

  <div class="buttons">
    <a
      [href]="crmLink"
      #app
      class="button"
      pplPopoverClose>
      <ppl-icon
        svgIcon="logo-coevera"
        width="56px"
        height="24px"
        [actionElement]="app"
        hoverEnabled="true"></ppl-icon>
      <ng-container i18n="@@CRM_Application">CRM Application</ng-container>
    </a>

    @if (hasAccessToCustomerPortal$ | async) {
      <a
        [href]="customerPortalLink"
        #customerPortal
        class="button"
        pplPopoverClose>
        <ppl-icon
          svgIcon="billing-switcher-blue"
          width="56px"
          height="24px"
          [actionElement]="customerPortal"
          hoverEnabled="true"></ppl-icon>
        <ng-container i18n="@@Billing">Billing</ng-container>
      </a>
    }
    @if (hasAccessToBusinessCenter$ | async) {
      <a
        [href]="businessCenterLink"
        #businessCenter
        class="button"
        pplPopoverClose>
        <ppl-icon
          svgIcon="business-center-switcher-blue"
          width="56px"
          height="30px"
          [actionElement]="businessCenter"
          hoverEnabled="true"></ppl-icon>
        Business Center
      </a>
    }
    @if (hasAccessToPartnerPortal$ | async) {
      <a
        [href]="partnerPortalLink"
        #partnerPortal
        class="button"
        pplPopoverClose>
        <ppl-icon
          svgIcon="partners-switcher-blue"
          width="56px"
          height="30px"
          [actionElement]="partnerPortal"
          hoverEnabled="true"></ppl-icon>
        Partner Portal
      </a>
    }
  </div>
</div>
